'use client';

import AppLayout from '@/components/AppLayout';
import PulseFeed from './components/PulseFeed';


export default function PulsePage() {
  return (
    <AppLayout>
      <div className="max-w-2xl mx-auto py-6 px-4">
        <PulseFeed />
      </div>
    </AppLayout>
  );
}
